import React from 'react';
import { Page } from './page';

export const Footer = () => {
  return (
      <Page />
  );
}

export default Footer;